import React from 'react';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';

import { FIELDS } from './new';
import { UPDATE_MAKE } from './queries';

const EditMake = ({ make, setShow, refetch }) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: make })
  });

  const [updateMake] = useMutation(UPDATE_MAKE, {
    onCompleted: () => setShow(false),
  });

  const onSubmit = input => {
    updateMake({
      variables: prepareInput(input, FIELDS),
      onCompleted: () => refetch(),
    });
  };

  return (
    <Modal title="Update Make" setShow={setShow}>
      <Fields fields={FIELDS} control={control} errors={errors} />

      <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
    </Modal>
  );
};

export default EditMake;
